import {showFinancialAidAwardLetters} from 'high-school-student/financial-aid-award-letter/utils';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {filter} from 'lodash';
import {fetchFeatureFlags} from 'shared/actions/feature-flags';
import {
  receiveEarnings,
  receiveInitialEarnings,
  setLoading,
  receiveEarningsOrder,
  updateEarningsOrder,
  setEarningFilter,
} from 'shared/college-earnings/actions/college-earnings';
import {fetchAdmissionLikelihoodScores} from 'high-school-student/college-earnings/actions/admission-likelihood';
import {selectApplicationManagementProps} from 'shared/application-management/selectors';
import {EARNING_FILTERS} from 'shared/application-management/filters';

export const mapStateToProps = (state) => {
  const {collegeEarnings, student} = state;

  const {
    earnings,
    totalCredits,
    juniorOrSenior,
    isBalancedListInfoAvailable,
    admissionLikelihoodTierCounts,
  } = selectApplicationManagementProps({
    student,
    collegeEarnings,
    admissionLikelihood: state.admissionLikelihood || {},
    collegeApplicationStatuses: state.collegeApplicationStatuses,
    courses: state.bulkEntryCourses,
  });

  const {earningFilter} = collegeEarnings;
  const filteredEarnings = filter(earnings, EARNING_FILTERS[earningFilter].filter);
  const showBuildYourListOnTrack = isBalancedListInfoAvailable || false;

  return {
    totalCredits,
    earningFilter,
    juniorOrSenior,
    showBuildYourListOnTrack,
    admissionLikelihoodTierCounts,
    studentId: student._id,
    earnings: filteredEarnings,
    loading: collegeEarnings.loading,
    animating: collegeEarnings.animating,
    showNewEarnings: collegeEarnings.showNewEarnings,
    previousEarnings: collegeEarnings.previousEarnings,
    followedCollegeIds: student ? student.followedCollegeIds : null,
    showFinancialAidAwardLettersLink: showFinancialAidAwardLetters(student),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      receiveEarnings,
      receiveInitialEarnings,
      setLoading,
      receiveEarningsOrder,
      updateEarningsOrder,
      setEarningFilter,
      fetchAdmissionLikelihoodScores,
      fetchFeatureFlags,
    },
    dispatch
  );

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
});

export default (child) => connect(mapStateToProps, mapDispatchToProps, mergeProps)(child);
